import React, { Component } from 'react'
import Footer from '../components/Footer'
import Mainmenu from '../components/Mainmenu'
import Navbar from '../components/Navbar'

import TalentDocumentsContent from './TalentDocumentsContent'
export default class TalentDocuments extends Component {
    render() {
        let talent_id = this.props.match.params.id;
        let document_id = this.props.match.params.document_id;
        return (
            <div class="wrapper">
                <Navbar />
                <Mainmenu />
                <TalentDocumentsContent talent_id={talent_id} document_id={document_id} />
                <Footer />

            </div>


        )
    }
}
